import { create } from 'zustand';
import { endpoints, type ServerConfig, type User } from '../services/api';

interface SessionStore {
  config: ServerConfig | null;
  user: User | null;
  loaded: boolean;
  load: () => Promise<void>;
  setUser: (u: User | null) => void;
  signOut: () => Promise<void>;
}

const offlineConfig: ServerConfig = {
  env: 'offline',
  features: { accounts: false, billing: false },
  licensePrice: { amount: 1000, currency: 'GBP' },
};

export const useSession = create<SessionStore>()((set) => ({
  config: null,
  user: null,
  loaded: false,
  load: async () => {
    const [config, me] = await Promise.allSettled([endpoints.config(), endpoints.me()]);
    set({
      config: config.status === 'fulfilled' ? config.value : offlineConfig,
      user: me.status === 'fulfilled' ? me.value.user : null,
      loaded: true,
    });
  },
  setUser: (user) => set({ user }),
  signOut: async () => {
    await endpoints.logout().catch(() => undefined);
    set({ user: null });
  },
}));

export const isLicensed = (u: User | null): boolean => u?.license === 'lifetime';
